import React from 'react';

export default function SomethingWentWrongIcon({ width = '486' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height="396" viewBox="0 0 486 396">
      <g fill="none" fillRule="evenodd">
        <ellipse
          cx="456.852"
          cy="376.205"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity=".1"
          rx="10.495"
          ry="25.478"
          transform="rotate(-45 456.852 376.205)"
        />
        <ellipse
          cx="458.656"
          cy="370.493"
          fill="#447B50"
          fillRule="nonzero"
          rx="5.633"
          ry="7.376"
        />
        <ellipse
          cx="458.656"
          cy="361.478"
          fill="#447B50"
          fillRule="nonzero"
          rx="5.633"
          ry="7.376"
        />
        <ellipse
          cx="458.656"
          cy="352.464"
          fill="#447B50"
          fillRule="nonzero"
          rx="5.633"
          ry="7.376"
        />
        <ellipse cx="458.656" cy="343.45" fill="#447B50" fillRule="nonzero" rx="5.633" ry="7.376" />
        <ellipse
          cx="458.656"
          cy="334.435"
          fill="#447B50"
          fillRule="nonzero"
          rx="5.633"
          ry="7.376"
        />
        <ellipse
          cx="458.656"
          cy="325.421"
          fill="#3F3D56"
          fillRule="nonzero"
          rx="5.633"
          ry="7.376"
        />
        <ellipse
          cx="458.656"
          cy="316.407"
          fill="#3F3D56"
          fillRule="nonzero"
          rx="5.633"
          ry="7.376"
        />
        <path
          fill="#5CEB7B"
          fillRule="nonzero"
          d="M479.745 254.72c.77-.98 1.472-2.011 2.1-3.088l-14.805-2.43 16.012.115c3.105-6.753 3.295-14.486.525-21.383L462.1 239.08l19.797-14.564c-5.054-8.75-14.573-13.943-24.667-13.458-10.093.486-19.07 6.569-23.262 15.763-4.192 9.195-2.896 19.96 3.357 27.899-1.2 1.523-2.232 3.173-3.077 4.919l19.216 9.975-20.476-6.878c-2.92 8.64-1.283 18.171 4.353 25.342-8.702 11.063-7.44 26.955 2.9 36.505 10.338 9.55 26.281 9.55 36.62 0 10.339-9.55 11.601-25.442 2.9-36.505 7.7-9.79 7.7-23.578 0-33.369l-.016.01z"
        />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M431.55 271.404c-.01 6.053 2.025 11.933 5.775 16.685-8.702 11.062-7.44 26.955 2.9 36.505 10.339 9.55 26.281 9.55 36.62 0 10.34-9.55 11.602-25.443 2.9-36.505 3.617-4.589-48.195-19.714-48.195-16.685z"
          opacity=".1"
        />
        <path
          fill="#FC7D4C"
          fillRule="nonzero"
          d="M422.424 374.828l-105.34-14.678-155.72 31.768c-.825.169-1.678.14-2.49-.083L50.9 362.095c-8.678-2.39-14.69-10.28-14.69-19.281V45.344c0-9.328 6.45-17.418 15.544-19.497L160.569.975c2.81-.642 5.726-.67 8.548-.08L305.534 29.4l5.35-1.129 110.18-23.194c10.81-2.275 21.416 4.643 23.691 15.452.286 1.354.43 2.735.43 4.12v330.37c0 11.047-8.955 20-20 20-.924 0-1.846-.063-2.761-.19z"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M423.659 20.643L423.659 358.853 309.046 342.883 169.717 371.306 168.593 371.532 57.734 341.003 57.734 46.946 172.825 20.643 298.709 46.946 303.497 45.938z"
        />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M161.364 391.918L164.834 0 305.534 29.4 310.884 28.271 317.084 360.15z"
          opacity=".1"
        />
        <g stroke="#444053" strokeWidth="1.575" opacity=".3">
          <path
            d="M255.334 0L255.397 109.987 301.072 109.987 301.072 64.838 379.297 64.838 388.484 53.056M1.034 34.913L170.872 34.913 181.372 30.188 185.572 30.188 185.572 136.238 259.072 136.238 262.222 145.688 262.222 193.463 318.922 193.463 318.922 252.525M208.005 252.525L208.005 136.238M388.484 221.371L208.005 221.371M343.282 0L343.282 252.525M.509 199.048L388.484 199.048M47.728 252.525L47.728 0M137.912 0L137.912 252.525M1.034 63.788L301.072 64.838M88.358.457L88.358 252.525"
            transform="translate(46.2 72.45)"
          />
          <path
            d="M.509 122.231L137.912 122.231 208.005 199.048M223.188 0L223.188 136.238M208.005 160.639L388.484 160.639"
            transform="translate(46.2 72.45)"
          />
        </g>
        <ellipse
          cx="269.211"
          cy="385.045"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity=".1"
          rx="17.561"
          ry="7.234"
          transform="rotate(-23.3 269.21 385.045)"
        />
        <ellipse
          cx="269.005"
          cy="382.184"
          fill="#447B50"
          fillRule="nonzero"
          rx="3.885"
          ry="5.082"
        />
        <ellipse
          cx="269.005"
          cy="375.968"
          fill="#447B50"
          fillRule="nonzero"
          rx="3.885"
          ry="5.082"
        />
        <ellipse
          cx="269.005"
          cy="369.757"
          fill="#447B50"
          fillRule="nonzero"
          rx="3.885"
          ry="5.082"
        />
        <ellipse
          cx="269.005"
          cy="363.547"
          fill="#447B50"
          fillRule="nonzero"
          rx="3.885"
          ry="5.082"
        />
        <ellipse
          cx="269.005"
          cy="357.331"
          fill="#447B50"
          fillRule="nonzero"
          rx="3.885"
          ry="5.082"
        />
        <ellipse cx="269.005" cy="351.12" fill="#3F3D56" fillRule="nonzero" rx="3.885" ry="5.082" />
        <ellipse
          cx="269.005"
          cy="344.909"
          fill="#3F3D56"
          fillRule="nonzero"
          rx="3.885"
          ry="5.082"
        />
        <path
          fill="#5CEB7B"
          fillRule="nonzero"
          d="M254.468 302.39c-.53-.667-1.014-1.369-1.45-2.1l10.206-1.68-11.024.083c-2.137-4.655-2.266-9.983-.357-14.736l14.804 7.654-13.65-10.038c3.485-6.028 10.045-9.605 17-9.27 6.955.335 13.14 4.527 16.029 10.862 2.889 6.336 1.997 13.754-2.31 19.224.818 1.053 1.522 2.19 2.1 3.392l-13.236 6.883 14.123-4.725c2.014 5.955.887 12.524-2.998 17.466 5.999 7.626 5.13 18.581-1.997 25.165s-18.117 6.584-25.244 0c-7.126-6.584-7.996-17.54-1.996-25.164-5.307-6.75-5.307-16.252 0-23v-.017z"
        />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M287.684 313.871c.007 4.173-1.395 8.227-3.98 11.503 6 7.625 5.13 18.58-1.996 25.164-7.127 6.584-18.117 6.584-25.244 0-7.126-6.583-7.996-17.539-1.996-25.164-2.494-3.15 33.216-13.571 33.216-11.503z"
          opacity=".1"
        />
        <ellipse
          cx="25.827"
          cy="364.655"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity=".1"
          rx="10.495"
          ry="25.478"
          transform="rotate(-45 25.827 364.655)"
        />
        <ellipse cx="27.631" cy="358.942" fill="#447B50" fillRule="nonzero" rx="5.633" ry="7.376" />
        <ellipse cx="27.631" cy="349.928" fill="#447B50" fillRule="nonzero" rx="5.633" ry="7.376" />
        <ellipse cx="27.631" cy="340.914" fill="#447B50" fillRule="nonzero" rx="5.633" ry="7.376" />
        <ellipse cx="27.631" cy="331.9" fill="#447B50" fillRule="nonzero" rx="5.633" ry="7.376" />
        <ellipse cx="27.631" cy="322.885" fill="#447B50" fillRule="nonzero" rx="5.633" ry="7.376" />
        <ellipse cx="27.631" cy="313.871" fill="#3F3D56" fillRule="nonzero" rx="5.633" ry="7.376" />
        <ellipse cx="27.631" cy="304.857" fill="#3F3D56" fillRule="nonzero" rx="5.633" ry="7.376" />
        <path
          fill="#5CEB7B"
          fillRule="nonzero"
          d="M48.72 243.17c.77-.98 1.472-2.011 2.1-3.087l-14.805-2.431 16.013.115c3.104-6.753 3.294-14.486.525-21.383L31.075 227.53l19.798-14.564c-5.055-8.75-14.574-13.943-24.668-13.458-10.093.486-19.07 6.569-23.262 15.763-4.192 9.195-2.896 19.96 3.357 27.899-1.2 1.523-2.232 3.173-3.076 4.919l19.215 9.975-20.476-6.878c-2.92 8.64-1.283 18.171 4.353 25.342-8.702 11.063-7.44 26.955 2.9 36.505 10.338 9.55 26.281 9.55 36.62 0 10.339-9.55 11.601-25.442 2.9-36.505 7.7-9.79 7.7-23.578 0-33.369l-.016.01z"
        />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M.525 259.854c-.01 6.053 2.025 11.933 5.775 16.685-8.702 11.062-7.44 26.955 2.9 36.505 10.339 9.55 26.281 9.55 36.62 0 10.34-9.55 11.602-25.443 2.9-36.505C52.337 271.95.525 256.825.525 259.853z"
          opacity=".1"
        />
        <g fillRule="nonzero">
          <path
            fill="#33619D"
            d="M118.371 50.465c0 16.755-8.657 31.487-21.741 39.969-1.97 1.279-3.616 2.997-4.775 5.04l-17.094 30.199c-.04.067-.077.132-.121.196-1.828 2.904-6.143 2.84-7.86-.196l-17.095-30.2c-1.156-2.04-2.8-3.757-4.768-5.032-13.271-8.6-21.99-23.629-21.743-40.677.39-27.143 23.83-48.978 51.47-46.743 24.478 1.97 43.727 22.458 43.727 47.444z"
            transform="translate(208 98)"
          />
          <path
            fill="#529DFE"
            d="M118.371 50.465c0 16.755-8.657 31.487-21.741 39.969-1.97 1.279-3.616 2.997-4.775 5.04l-17.094 30.199c-.04.067-.077.132-.121.196-.044-.064-.083-.129-.121-.196l-17.096-30.2c-1.155-2.04-2.799-3.758-4.767-5.033-13.272-8.6-21.991-23.628-21.743-40.676C31.267 25.206 50.49 4.98 74.645 3.02c24.477 1.97 43.726 22.458 43.726 47.444z"
            transform="translate(208 98)"
          />
          <path
            fill="#EAEAEA"
            d="M105.917 50.408c0 19.416-15.743 35.147-35.146 35.147-19.413 0-35.148-15.736-35.148-35.147 0-20.864 18.111-37.227 39.017-34.932 17.59 1.926 31.277 16.832 31.277 34.932z"
            transform="translate(208 98)"
          />
          <path
            fill="#FFF"
            d="M105.917 50.408c0 18.104-13.688 33.009-31.277 34.936-17.591-1.927-31.278-16.832-31.278-34.936 0-18.1 13.687-33.006 31.278-34.932 17.59 1.926 31.277 16.832 31.277 34.932z"
            transform="translate(208 98)"
          />
          <path
            fill="#F44545"
            d="M91.44 65.062c0 1.513-.58 3.03-1.736 4.186-.412.412-.87.752-1.356 1.015-2.248 1.227-5.119.887-7.019-1.015l-9.555-9.555c-.552-.552-1.454-.552-2.01 0l-3.149 3.15-6.402 6.405c-.412.412-.868.75-1.355 1.015-.88.481-1.856.72-2.835.72-1.513 0-3.03-.577-4.186-1.735-2.312-2.311-2.312-6.06 0-8.372l9.555-9.555c.553-.555.553-1.455 0-2.01l-9.555-9.555c-1.155-1.155-1.734-2.67-1.734-4.186s.579-3.03 1.734-4.186c1.9-1.903 4.773-2.242 7.021-1.015.487.266.943.603 1.355 1.015l8.58 8.58.97.972c.557.555 1.459.555 2.011 0l1.829-1.826 7.726-7.726c1.156-1.156 2.67-1.736 4.187-1.736.975 0 1.95.24 2.832.721.486.266.944.603 1.356 1.015 2.313 2.311 2.313 6.06 0 8.372L80.15 49.31c-.556.555-.556 1.455 0 2.01l9.554 9.555c1.156 1.155 1.735 2.672 1.735 4.186z"
            transform="translate(208 98)"
          />
          <path
            fill="#529DFE"
            d="M22.317 3.53c.813-.798.825-2.101.028-2.913-.797-.812-2.1-.824-2.912-.027C12.37 7.52 6.618 17.459 3.235 28.577-.148 39.695-.907 51.154 1.098 60.844c.2.972 1.058 1.642 2.014 1.642.138 0 .279-.013.42-.043 1.114-.23 1.83-1.32 1.599-2.434-1.867-9.026-1.14-19.763 2.045-30.233 3.185-10.47 8.563-19.79 15.141-26.247z"
            transform="translate(208 98)"
          />
          <path
            fill="#33619D"
            d="M30.142 8.401c-.778-.83-2.081-.873-2.912-.095C21.1 14.043 16.128 22.45 13.23 31.98c-2.9 9.53-3.455 19.283-1.56 27.461.22.953 1.068 1.596 2.005 1.596.154 0 .31-.017.467-.054 1.108-.256 1.797-1.363 1.542-2.471-1.735-7.487-1.206-16.483 1.487-25.332 2.692-8.85 7.266-16.617 12.876-21.868.83-.777.873-2.08.096-2.912z"
            transform="translate(208 98)"
          />
          <path
            fill="#FB5858"
            d="M91.44 65.062c0 1.513-.58 3.03-1.736 4.186-.412.412-.87.752-1.356 1.015-2.248 1.227-5.119.887-7.019-1.015l-9.555-9.555c-.552-.552-1.454-.552-2.01 0l-3.149 3.15c-.55-2.577-.842-5.252-.842-7.997 0-5.28 1.077-10.31 3.02-14.881l.97.97c.557.556 1.459.556 2.011 0l1.829-1.825 7.726-7.726c1.156-1.156 2.67-1.736 4.187-1.736.975 0 1.95.24 2.832.721.486.266.944.603 1.356 1.015 2.313 2.311 2.313 6.06 0 8.372L80.15 49.31c-.556.555-.556 1.455 0 2.01l9.554 9.555c1.156 1.155 1.735 2.672 1.735 4.186z"
            transform="translate(208 98)"
          />
        </g>
      </g>
    </svg>
  );
}
